// extracted by mini-css-extract-plugin
module.exports = {"button":"style-module--button--jI5gL"};